
import React from "react";
import { AlertCircle, Clipboard } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export function ProgramStructureEmpty() {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white/90 flex items-center gap-2 border-b border-white/20 pb-2">
        <Clipboard className="h-5 w-5" />
        Program Structure
      </h3>
      <Alert className="bg-amber-950/30 border-amber-600/50">
        <AlertCircle className="h-4 w-4 text-amber-400" />
        <AlertTitle className="text-amber-400">No Program Structure</AlertTitle>
        <AlertDescription className="text-white/70">
          <p>No program data just yet, check back soon.</p>
        </AlertDescription>
      </Alert>
    </div>
  );
}
